module.exports = __webpack_public_path__ + "img/title5@2x.a9206b09.png";